export const NOTIFICATIONS_PAGE_TITLE = 'Notification'
export const NOTIFICATIONS_PAGE_SUBTITLE = 'View your all notification here'
export const NOTIFICATIONS_CARD_TITLE = 'Notifications'

export function formatNotificationsCardTitle(totalCount: number): string {
  return `${totalCount} Notifications`
}

export function formatPanelTitle(unreadCount: number): string {
  return `Notifications (${unreadCount})`
}

export const NOTIFICATIONS_MARK_ALL_READ = 'Mark all as Read'
export const NOTIFICATIONS_CLEAR_READ = 'Clear Read Notifications'
export const NOTIFICATIONS_VIEW_ALL = 'View All Notifications'
export const NOTIFICATIONS_PANEL_EMPTY = 'No notifications yet.'
export const NOTIFICATIONS_PANEL_LOAD_ERROR = 'Unable to load notifications. Please try again.'
export const NOTIFICATIONS_PAGE_LOAD_ERROR = 'Unable to load notifications. Please try again.'
export const NOTIFICATIONS_LOAD_MORE_ERROR = 'Unable to load more. Please try again.'
export const NOTIFICATIONS_CONNECTION_LOST = 'Connection lost. Refresh to see latest.'
export const NOTIFICATIONS_RETRY = 'Retry'
export const NOTIFICATIONS_END_OF_LIST = "You've reached the end"
export const NOTIFICATIONS_UNREAD_TAB = 'Unread'
export const NOTIFICATIONS_READ_TAB = 'Read'
